export default [
    {
        path: 'condutor',
        component: () => import(
            '@/views/transporte-paciente/condutor/Index'
        ),
        redirect: 'condutor/list',
        children: [
            {
                name: 'transporte-paciente-condutor-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/condutor/List'
                ),
            },
            {
                name: 'transporte-paciente-condutor-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/condutor/Form'
                ),
            },
            {
                name: 'transporte-paciente-condutor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/condutor/Form'
                ),
            },
        ],
    },
]